import { isBrowser } from '@jouzen/ecom-utils';

const DOCUMENT = isBrowser() ? document : ({} as Window['document']);

const getPageInfo = ({ location, referrer, title } = DOCUMENT) => {
  return {
    path: location.pathname,
    referrer: referrer,
    search: location.search,
    title: title,
    url: location.href,
  };
};

export default getPageInfo;
